/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/pointManage',
    component: Layout,
    subMenu:true,
    meta: {
      title: '积分管理',
      icon: 'component',
    },
    children: [
      {
        path: '/pointManage/pointManage',
        component: () => import('@/myviews/AA_pointManage/pointManage.vue'),
        alwaysShow: false,
        icon: 'message',
        name: '积分基础设置',
        meta: {
          title: '积分基础设置',
        }
      },
      {
        path: '/pointManage/beansCardDetail',
        component: () => import('@/myviews/BeansCard/BeansCard.vue'),
        alwaysShow: false,
        icon: 'message',
        name: '积分明细',
        meta: {
          title: '积分明细',
        }
      }
    ]
  },
]



// WEBPACK FOOTER //
// ./src/router/diabetesManage/AA_pointManage.js